import { AuthenticationService } from './services/authentication.service';
import { SettingsService } from './services/settings.service';
import { AuthenticationObserver } from './services/authentication.observer';
import { AuthGuard } from './guard/auth-guard.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './components/login.component';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { RegisterComponent } from './components/register.component';
import { InterfaceService } from './services/interface.service';
import { PasswordRequestComponent } from './components/password-request.component';
import { PasswordRequestConfirmationComponent } from './components/password-request-confirmation.component';
import { PasswordResetComponent } from './components/password-reset.component';
import { AccountUnlockedConfirmationComponent } from './components/account-unlocked-confirmation.component';
import { AccountActivationComponent } from './components/activation-request.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MfaComponent } from './components/mfa.component';

@NgModule({
  imports: [CommonModule, FormsModule, HttpClientModule, NgbModule, RouterModule, ToastModule],
  declarations: [
    LoginComponent,
    RegisterComponent,
    PasswordRequestComponent,
    PasswordRequestConfirmationComponent,
    PasswordResetComponent,
    AccountUnlockedConfirmationComponent,
    AccountActivationComponent,
    MfaComponent,
  ],
  providers: [
    AuthenticationService,
    SettingsService,
    AuthenticationObserver,
    AuthGuard,
    InterfaceService,
    MessageService,
  ],
})
export class AuthenticationModule {}
